var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaintenance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "35px",
    height: "32px",
    viewBox: "0 0 35 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0C83D7A3-194B-4D45-BE3B-BD78B9DFA4AD") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 252,
    height: 76,
    rx: 3
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SYNC-&-Maps",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3.3_SYNC:-SYNC-+-Maps-Updates",
    transform: "translate(-580.000000, -1024.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#F4F4F4",
    x: 0,
    y: 0,
    width: 1440,
    height: 3684
  }), /*#__PURE__*/React.createElement("g", {
    id: "SYNC",
    transform: "translate(99.000000, 762.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "open-accordion",
    transform: "translate(0.000000, 158.000000)",
    fill: "#EEEEEE"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "base",
    x: 0,
    y: 0,
    width: 770,
    height: 366
  })), /*#__PURE__*/React.createElement("g", {
    id: "check-box-selection-II",
    transform: "translate(61.000000, 239.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cards-/-Promotion-Showroom-/-SMALL-Copy-5",
    transform: "translate(225.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    stroke: "#DBDBDB",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Entertainment/USB/40",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(195.000000, 23.000000)",
    id: "maintenance-schedule-40"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.916667, 4.333333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7498751,0 C16.9276247,0 17.9712469,0.688794487 18.3442315,1.70854633 L18.3442315,1.70854633 L19.5440295,4.99964 L20.052979,4.99964 C21.0598539,4.99964 21.8756431,5.747234 21.8756431,6.66618667 L21.8756431,6.66618667 L20.052979,6.66618667 L20.052979,14.1656467 C20.052979,14.627643 19.6450844,14.99892 19.141647,14.99892 L19.141647,14.99892 L17.318983,14.99892 C16.8137082,14.99892 16.407651,14.627643 16.407651,14.1656467 L16.407651,14.1656467 L16.407651,13.3323733 L11.8491535,13.3323733 L11.8491535,21.6667867 L14.5849869,21.6667867 C15.5900245,21.6667867 16.407651,22.4127007 16.407651,23.3333333 L16.407651,23.3333333 L5.46982945,23.3333333 C5.46982945,22.4127007 6.28561859,21.6667867 7.29249347,21.6667867 L7.29249347,21.6667867 L10.0264895,21.6667867 L10.0264895,13.3323733 L5.46982945,13.3323733 L5.46982945,14.1656467 C5.46982945,14.627643 5.06193488,14.99892 4.55849744,14.99892 L4.55849744,14.99892 L2.73399604,14.99892 C2.23239597,14.99892 1.82266403,14.627643 1.82266403,14.1656467 L1.82266403,14.1656467 L1.82266403,11.6658267 L1.82633876,11.6658267 L1.82266403,6.66618667 L0,6.66618667 C0,5.747234 0.815789144,4.99964 1.82266403,4.99964 L1.82266403,4.99964 L2.33345093,4.99964 L3.53324892,1.70854633 C3.90439623,0.688794487 4.94801838,0 6.12576802,0 L6.12576802,0 L15.7498751,0 Z M27.3440027,6.82024147 C28.404161,7.16463867 29.1666667,8.08023133 29.1666667,9.16718267 C29.1666667,10.252454 28.404161,11.1680467 27.3440027,11.5124439 L27.3440027,11.5124439 L27.3440027,19.1664627 C27.3440027,19.628459 26.9361081,19.999736 26.434508,19.999736 C25.9292332,19.999736 25.523176,19.628459 25.523176,19.1664627 L25.523176,19.1664627 L25.523176,11.5124439 C24.4611802,11.1680467 23.6986746,10.252454 23.6986746,9.16718267 C23.6986746,8.08023133 24.4611802,7.16463867 25.523176,6.82024147 L25.523176,6.82024147 L25.523176,9.16718267 C25.523176,9.625819 25.9292332,9.998776 26.434508,9.998776 C26.9361081,9.998776 27.3440027,9.625819 27.3440027,9.16718267 L27.3440027,9.16718267 L27.3440027,6.82024147 Z M15.7498751,1.66654667 L6.12576802,1.66654667 C5.73440971,1.66654667 5.38714812,1.89670483 5.26037008,2.23606211 L5.26037008,2.23606211 L3.64716542,6.66618667 L3.64900279,11.6658267 L18.230315,11.6658267 L18.230315,6.66618667 L16.615273,2.23606211 C16.4903323,1.89670483 16.1412334,1.66654667 15.7498751,1.66654667 L15.7498751,1.66654667 Z M16.406916,8.33323733 L16.406916,9.999784 L14.584252,9.999784 L14.584252,8.33323733 L16.406916,8.33323733 Z M7.29175854,8.33323733 L7.29175854,9.999784 L5.4690945,9.999784 L5.4690945,8.33323733 L7.29175854,8.33323733 Z M15.0939365,3.33309333 L16.3084334,6.66618667 L5.56720969,6.66618667 L6.78354395,3.33309333 L15.0939365,3.33309333 Z",
    id: "POI-Auto-Repair",
    fill: "#00095B"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintenance);
export default __webpack_public_path__ + "static/media/maintenance.142ccbf0700a6c83ef2174f2d97b9cbb.svg";
export { ForwardRef as ReactComponent };